import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a right arrow icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/arrow-right?f=classic&s=solid
 */
export const ArrowRightIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faArrowRight} {...props} />;
};
